
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { AttachmentBox, Margin, Size, FlexDirection, Flex, FlexItem, FlexAlign } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const attachment = {
  fileName: 'DummyFile.jpg',
  progress: 1
};
export const secondAttachment = {
  fileName: 'SecondDummyFile.jpg',
  progress: 0.6
};
export const onClickDownload = () => {};
export const onClickClose = () => {};

const layoutProps = {
  attachment,
secondAttachment,
onClickDownload
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Attachment Box`}</h1>
<p>{`Used to display attachment components.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { AttachmentBox } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>



<Playground __position={0} __code={`<div style={{ width: '300px'}}>
  <AttachmentBox fileName="DummyFile.jpg" />
</div>`} component={AttachmentBox} mdxType="Playground">
  <div style={{
        width: '300px'
      }}>
    <AttachmentBox fileName="DummyFile.jpg" mdxType="AttachmentBox" />
  </div>
</Playground>
<p>{`You can add a progress, plus mechanisms to handle download and removal.`}</p>
<Playground __position={1} __code={`<div style={{ width: '300px'}}>
  <Flex direction={FlexDirection.VERTICAL} align={FlexAlign.START}>
    <FlexItem style={{width: '100%'}}>
      <Margin size={{ bottom: Size.SMALL }}>
        <AttachmentBox fileName="Second.xls" progress={0.6}/>
      </Margin>
    </FlexItem>
    <FlexItem style={{width: '100%'}}>
      <Margin size={{ bottom: Size.SMALL }}>
        <AttachmentBox fileName="Third.zip" progress={0.6} onClickClose={onClickClose}/>
      </Margin>
    </FlexItem>
    <FlexItem style={{width: '100%'}}>
      <Margin size={{ bottom: Size.SMALL }}>
        <AttachmentBox fileName="Fourth.mp4" onClickDownload={onClickDownload} onClickClose={onClickClose}/>
      </Margin>
    </FlexItem>
  </Flex>
</div>`} mdxType="Playground">
  <div style={{
        width: '300px'
      }}>
    <Flex direction={FlexDirection.VERTICAL} align={FlexAlign.START} mdxType="Flex">
      <FlexItem style={{
            width: '100%'
          }} mdxType="FlexItem">
        <Margin size={{
              bottom: Size.SMALL
            }} mdxType="Margin">
          <AttachmentBox fileName="Second.xls" progress={0.6} mdxType="AttachmentBox" />
        </Margin>
      </FlexItem>
      <FlexItem style={{
            width: '100%'
          }} mdxType="FlexItem">
        <Margin size={{
              bottom: Size.SMALL
            }} mdxType="Margin">
          <AttachmentBox fileName="Third.zip" progress={0.6} onClickClose={onClickClose} mdxType="AttachmentBox" />
        </Margin>
      </FlexItem>
      <FlexItem style={{
            width: '100%'
          }} mdxType="FlexItem">
        <Margin size={{
              bottom: Size.SMALL
            }} mdxType="Margin">
          <AttachmentBox fileName="Fourth.mp4" onClickDownload={onClickDownload} onClickClose={onClickClose} mdxType="AttachmentBox" />
        </Margin>
      </FlexItem>
    </Flex>
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;